import { callApi } from '../../libs'

const checkWaitingForPaymentBooking = (data) => {
    return new Promise(async (resolve, reject) => {
        const url = `${process.env.REACT_APP_API_COVID19}/api/map-routes/check/booking`
        const method = 'post'
        const body = data
        try {
            const response = await callApi(method, url, body, null)
            resolve(response)
        } catch (error) {
            reject(error)
        }
    })
}

export default checkWaitingForPaymentBooking